import { IAppVersionBody, IAppVersionResponse } from "../../utils/types";
import { apiManager } from "../api-manager";

export const appVersion = async (body: IAppVersionBody) => {
  const res = await apiManager.post<IAppVersionResponse>("/app/version", body);
  return res;
};
